import React, { FC } from 'react';
import { MasterSheetList as V2MasterSheetList, MasterSheetEdit as V2MasterSheetEdit } from '../master-sheet-v2/views';
import { DRYWALL_CONFIG } from '../master-sheet-v2/config';

const WarrantyList: FC<any> = props => (
  <V2MasterSheetList config={DRYWALL_CONFIG} {...props} />
);

const WarrantyEdit: React.FC = () => <V2MasterSheetEdit config={DRYWALL_CONFIG} />;

export default {
  edit: WarrantyEdit,
  list: WarrantyList,
  name: 'job-warranty-sheet',
  label: 'Warranty List',
  to: '/job-warranty-sheet',
};
